__turbopack_context__.v({
  "container": "ky8I2q_container",
  "explainButton": "ky8I2q_explainButton",
  "highlight": "ky8I2q_highlight",
});
